export const EDIT_MODE = "EDIT_MODE";
export const CREATE_MODE = "CREATE_MODE";
